// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from 'worker-loader!./worker';

import './custom.d.ts';

export default Worker;
